import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import mensagens from '@/util/mensagens'
import { BToast, BSpinner } from 'bootstrap-vue'
import { mapState } from 'vuex'
import util from '@/util'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import redirecionamento from '@/util/redirecionamentoRotasConteudo'

export default {
  name: 'cadastro-noticias',
  components: {
    cabecalho,
    menuLateral,
    Datefield,
    'b-toast': BToast,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapState('auth', ['tipoDeAcesso'])
  },

  data: () => {
    return {
      editorDeTexto: {
        editor: ClassicEditor,
        config: {
          language: 'pt-br'
        }
      },
      formulario: {
        id: null,
        date: null,
        title: null,
        image_file_name: null,
        image_content_type: null,
        image_file_size: null,
        summary: null,
        text: null,
        author: null,
        source: null,
        source_link: null,
        created_at: null,
        updated_at: null,
        type: 'internal'
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        },
        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },

  mounted () {
    let id = this.$route.params.id
    if (!util.valorEhNulo(id)) {
      this.obterNoticia(id)
    }
  },

  methods: {
    async obterNoticia (id) {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        const resposta = await this.axios.get('/noticias/noticia/' + id)
        this.formulario.id = resposta.data.retorno.dados.id
        this.formulario.date = util.formatarData(resposta.data.retorno.dados.date, 'YYYY-MM-DD')
        this.formulario.title = resposta.data.retorno.dados.title
        this.formulario.image_file_name = resposta.data.retorno.dados.image_file_name
        this.formulario.image_content_type = resposta.data.retorno.dados.image_content_type
        this.formulario.image_file_size = resposta.data.retorno.dados.image_file_size
        this.formulario.summary = resposta.data.retorno.dados.summary
        this.formulario.text = resposta.data.retorno.dados.text
        this.formulario.author = resposta.data.retorno.dados.author
        this.formulario.source = resposta.data.retorno.dados.source
        this.formulario.source_link = resposta.data.retorno.dados.source_link
        this.formulario.created_at = resposta.data.retorno.dados.created_at
        this.formulario.updated_at = resposta.data.retorno.dados.updated_at
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    async salvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        let resposta = null
        let dadosFormulario = util.mapearObjetos(this.formulario, {})

        dadosFormulario.date = util.formatarData(dadosFormulario.date)

        if (util.valorVazio(dadosFormulario.id)) {
          resposta = await this.axios.post('/noticias/salvar', dadosFormulario)
        } else {
          resposta = await this.axios.put('/noticias/salvar', dadosFormulario)
        }
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        this.$router.push({ name: redirecionamento.obterRota(this.tipoDeAcesso, 'noticias') }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        })
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
      }
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
